import { getCreatedProperties, getIdeasInCreationCount } from './properties/index.tsx';
import { createIssueHook } from './utils.tsx';

export const useCreatedIssues = createIssueHook(getCreatedProperties);
export const useIdeasInCreationCount = createIssueHook(getIdeasInCreationCount);
